import { AxiosInstance } from '@service/axios-instance';
import { TSignUpData } from '@models/sign-up-data';

export function createUser({
  username,
  name,
  email,
  password,
  role,
  company,
}: TSignUpData) {
  console.log("creating USER......", { username, name, email, company, role })
  return AxiosInstance.post('/users/register', {
    username,
    name,
    email,
    password,
    'function': role,
    employed_by: company ? company.trim() : "",
  });
}

export function getUsers() {
  const db = localStorage.getItem('selectedDB');
  const params = db ? { db } : {};
  const response = AxiosInstance.get('/users/get_info', {
    params,
    withCredentials: true,
  }).then((res) => res).catch(e => { console.log("user/get_info error") });

  return response;
}

export async function updateUser({
  username,
  active,
  roles,
}: {
  username: string;
  active?: boolean;
  roles?: string[];
}) {
  try {
    const response = await AxiosInstance.put(
      '/users/update',
      {
        username,
        active,
        roles,
      },
      {
        withCredentials: true,
      }
    );

    return response.data; // Retorne apenas os dados da resposta
  } catch (error) {
    console.error('Error updating user status:', error);
    throw error; // Rejeite a promessa com o erro para lidar com ele mais tarde
  }
}

export async function deleteUser(username: string) {
  try {
    const response = await AxiosInstance.delete(
      '/users/delete',
      {
        data: { username },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
}
